export interface ApplicationPortfolioDetailPayload {
  applicationRequestReceiptDate: string;
  applicationOfferRequestDate: string;
  pirfFile?: PirfFileType;
  insuredApprovedLenderCode: string;
  portfolioNumberOfLoansSubmitted: number;
  insuredApprovedLenderName: InsuredApprovedLenderName;
  portfolioLastStatusUpdateTimestamp: string;
  portfolioAmountSubmitted: number;
  portfolioOccupancyType: string;
  portfolioTermInsurance?: number;
  requestType?: string;
}

interface InsuredApprovedLenderName {
  englishName: string;
  frenchName: string;
}

interface PirfFileType {
  name: string;
  fileId: string;
}

export interface LoanSummaryResponse {
  totalAmount: number;
  totalCount: number;
  loanValidationDetails: LoanValidationDetailsType[];
}

export interface LoanValidationDetailsType {
  amountPercentage: number;
  countPercentage: number;
  totalAmount?: number | undefined;
  loanStatus?: string;
  loanStatusName?: string | undefined;
  color?: string | undefined;
  count: number | undefined;
  amount: number | undefined;
  loanStatusCode?: string | undefined;
}

export enum ResidenceOccupancyTypeCode {
  OwnerOccupied = '01',
  Rental = '02',
  HELOC1P = '03',
  HELOC2P = '04',
  SelfEmployed = '05'
}

export enum PoolPrecisionTypeCode {
  NewPortfolio = '01',
  Replacement = '02',
  Cancellation = '04',
  Resubmission = '05'
}

export enum PortfolioLoanRecordStatusCode {
  RECEIVED = '01',
  PASS = '02',
  FAIL = '03',
  REVIEW = '04',
  DELETE = '09',
  Total = 'Total'
}

export enum PortfolioLoanStatusCode {
  Entered = '00',
  Received = '01',
  Cancelled = '02',
  Rejected = '03',
  Refused = '04',
  Withdrawn = '05',
  Approved = '06',
  Issued = '07',
  Risked = '08',
  Finalized = '09',
  Saved = '10',
  Priced = '11',
  Offer = '12',
  Lock = '14',
  Expired = '15',
  New = '90',
  Rerisk = '91',
  Critical = '99'
}
